<template>
  <div class="website" :class="{ 'is-portrait': portrait }">
    <video class="website__video" playsinline muted loop>
      <source v-for="source in sources" :src="source">
    </video>
    <span v-if="!portrait" class="website__bar">
      <span class="website__button"></span>
      <span class="website__button"></span>
      <span class="website__button"></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'website-video',
  props: ['sources', 'portrait']
}
</script>

<style lang="sass" scoped>

@import "../assets/sass/utilities/variables"
@import "../assets/sass/utilities/mixins"

$bar-height: 15px
$bar-height--large: 30px

.website
  position: relative
  width: 75vw
  height: auto
  margin-left: auto
  margin-right: auto
  padding-top: $bar-height
  display: inline-block
  overflow: hidden
  border-radius: 3px
  +medium
    max-width: 700px
    padding-top: $bar-height--large
    border-radius: 4px
  &.is-portrait
    width: 75vw
    max-width: 375px
    padding-top: 0
    box-shadow: 0 0 30px rgba(0,0,0,0.2)
    margin: 0 auto

.website__video
  width: 100%
  border: none
  .is-portrait &
    top: 0
  +medium
    top: $bar-height--large

.website__bar
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: $bar-height
  background-color: lighten($light-grey, 10%)
  padding-left: 5px
  display: flex
  align-items: center
  +medium
    padding-left: 10px
    height: $bar-height--large

.website__button
  width: 5px
  height: 5px
  border-radius: 50%
  margin-right: 4px
  +medium
    margin-right: 8px
    width: 10px
    height: 10px
  &:nth-of-type(1)
    background-color: #ff5f57
  &:nth-of-type(2)
    background-color: #ffbf2e
  &:nth-of-type(3)
    background-color: #2bca41

</style>



// WEBPACK FOOTER //
// WebsiteVideo.vue?627805b4